import { createElement, forwardRef } from 'react';
import getDisplayName from 'react-display-name';
import hoistNonReactStatic from 'hoist-non-react-statics';

interface Opt {
  name?: string;
  enableRef?: boolean;
  blacklist?: string[];
}

type THocFn = (Comp: React.ComponentType<any>) => React.ComponentType<any>;

export function createHocRef(
  fn: THocFn,
  opt: Opt = {},
): (Comp: React.ComponentType<any>) => React.ComponentType<any> {
  const { name, enableRef = false, blacklist = [] } = opt;

  const _blacklist = blacklist.reduce(
    (rt: any, cur) => ((rt[cur] = true), rt),
    {},
  );

  return (WrappedComponent: React.ComponentType<any>) => {
    const _NewComponent = fn(WrappedComponent);

    return returnWithApp(_NewComponent);

    function returnWithApp(NewComponent: React.ComponentType<any>) {
      if (enableRef && forwardRef) {
        const forwarded = forwardRef(function forwardHocRef(props, ref) {
          return createElement(NewComponent, {
            ...props,
            ReactforwardedRef: ref,
          });
        });

        forwarded.displayName = `${name ||
        NewComponent.name ||
        'createHocRef'}(${getDisplayName(WrappedComponent)})`;

        return hoistNonReactStatic(forwarded, WrappedComponent, _blacklist);
      }

      return hoistNonReactStatic(NewComponent, WrappedComponent, _blacklist);
    }
  };
}
